module.exports = __webpack_public_path__ + "static/img/m-tilte.d251b53e.png";